import React, { useContext, useEffect, useState } from 'react'
import { Box, Heading } from 'rebass/styled-components'
import { ThemeContext } from 'styled-components'
import SwiperFilmStrip from '../swiper/FilmStrip'
import Spacer from '../general/Spacer'

const Carousel = ({ options, data, initialFeed }) => {
    const theme = useContext(ThemeContext)
    const [carouselData, setData] = useState(initialFeed)
    useEffect(() => {
        setData(data)
    }, [data])
    const isSSR = typeof window === 'undefined'
    return (
        <>
            {!isSSR && (
                <Box
                    sx={{
                        overflow: 'hidden',
                    }}
                >
                    <Spacer spacing={options.spacing}>
                        {options.heading && (
                            <Box
                                pb='xxs'
                                mb='lg'
                                sx={{
                                    borderColor: options.borderColor,
                                    borderStyle: 'solid',
                                    borderWidth: '0 0 1px',
                                    display: 'block',
                                }}
                            >
                                <Heading
                                    as='h3'
                                    variant='h3'
                                    sx={{
                                        fontSize: '16px',
                                        fontWeight: '700',
                                        letterSpacing: '4px',
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    {options.heading}
                                </Heading>
                            </Box>
                        )}
                        <SwiperFilmStrip
                            options={{
                                type: options.type,
                                direction: 'horizontal',
                                data: options.data,
                                showTitle: true,
                                showCaption: true,
                                spaceBetween: 20,
                                slidesPerView:
                                    window.innerWidth <
                                    parseInt(theme.breakpoints.sm, 10)
                                        ? 'auto'
                                        : 4,
                            }}
                            slides={carouselData}
                        />
                    </Spacer>
                </Box>
            )}
        </>
    )
}

export default Carousel
